import type { ReactNode } from 'react';

/**
 * 확인/입력용 모달 — 레거시 #modalOrder(부트스트랩 modal) 대응.
 * 일괄 처리 확인과 철거 신청 확인에 공용으로 쓴다.
 */
export function Modal({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <div className="modal-back" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal__head">
          <h3>{title}</h3>
          <button type="button" className="link" onClick={onClose}>
            닫기
          </button>
        </div>
        <div className="modal__body">{children}</div>
      </div>
    </div>
  );
}
